<template>
    <v-card class="pa-4" max-width="600">

        <v-select v-model="selectedOption"
                  :items="options"
                  item-value="id"
                  item-text="value"
                  :label="$t('SelectDatePart')"
                  outlined
                  dense />
        
        
        <div v-if="selectedOption === 'year'">
            <Hijri v-model="fromYear" :typeDate="'year'" :max="maxHijriYear" :label="$t('FromHijriYear')" />
            <Hijri v-model="toYear" :typeDate="'year'" :min="minHijriYear" :label="$t('ToHijriYear')" />
        </div>

        <div v-if="selectedOption === 'month'">
            <Hijri v-model="fromMonth" :typeDate="'month'" :max="maxHijriMonth" :label="$t('FromHijriMonth')" />
            <Hijri v-model="toMonth" :typeDate="'month'" :min="minHijriMonth" :label="$t('ToHijriMonth')" />
        </div>

        <div v-if="selectedOption === 'date'">
            <Hijri v-model="fromDate" :typeDate="'date'" :max="maxHijriDate" :label="$t('FromDayHijri')" />
            <Hijri v-model="toDate" :typeDate="'date'" :min="minHijriDate" :label="$t('ToDayHijri')" />
        </div>
    </v-card>
</template>

<script>
    import moment from 'moment-hijri'
    import Hijri from '@/components/controls/Hijri.vue'

    export default {
        components: {
            Hijri
        },
        props: {
            value: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                options: [
                    { id: 'year', value: this.$t('Year') },
                    { id: 'month', value: this.$t('Month') },
                    { id: 'date', value: this.$t('Day') }
                ],
                selectedOption: null,
                fromYear: null,
                toYear: null,
                fromMonth: null,
                toMonth: null,
                fromDate: null,
                toDate: null,
                maxHijriYear: null,
                minHijriYear: null,
                maxHijriMonth: null,
                minHijriMonth: null,
                maxHijriDate: null,
                minHijriDate: null
            }
        },
        computed: {
            hijriYears() {
                const currentYear = moment().iYear()
                return Array.from({ length: 100 }, (_, i) => (currentYear - i).toString()).reverse()
            },
            hijriMonths() {
                return [
                    { text: this.$t('Muharram'), value: 1 },
                    { text: this.$t('Safar'), value: 2 },
                    { text: this.$t('RabiAlAwwal'), value: 3 },
                    { text: this.$t('RabiAlThani'), value: 4 },
                    { text: this.$t('JumadaAlAwwal'), value: 5 },
                    { text: this.$t('JumadaAlThani'), value: 6 },
                    { text: this.$t('Rajab'), value: 7 },
                    { text: this.$t('Shaaban'), value: 8 },
                    { text: this.$t('Ramadan'), value: 9 },
                    { text: this.$t('Shawwal'), value: 10 },
                    { text: this.$t('DhuAlQidah'), value: 11 },
                    { text: this.$t('DhuAlHijjah'), value: 12 }
                ]
            },
            formattedValue() {
                if (this.selectedOption === 'year') {
                    return `year#${this.formatDate(this.fromYear) || ''}$${this.formatDate(this.toYear) || ''}`
                } else
                    if (this.selectedOption === 'month') {
                        const dt = `month#${this.formatDate(this.fromMonth) || ''}$${this.formatDate(this.toMonth) || ''}`

                        return dt
                    } else
                        if (this.selectedOption === 'date') {
                            return `date#${this.formatDate(this.fromDate) || ''}$${this.formatDate(this.toDate) || ''}`
                        } else {
                            return ''
                        }

            },
            formattedFromDate() {
                return this.formatDate(this.fromDate)
            },
            formattedToDate() {
                return this.formatDate(this.toDate)
            }
        },
        methods: {
            formatDate(date) {
                if (!date) return ''
                moment.locale('en-us')
                if (this.selectedOption === 'date') {
                    return moment(date).format('iYYYY-iMM-iDD')
                } else if(this.selectedOption === 'month'){
                    const formattedDate = moment(date).format('YYYY-MM-DD')
                    const hijriDate = moment(formattedDate, 'iYYYY-iMM', true)
                    if (hijriDate.isValid()) {
                        return date
                    } else {
                        return moment(date).format('iYYYY-iMM')
                    }
                }else if(this.selectedOption === 'year'){
                    const formattedDate = moment(date).format('YYYY-MM-DD')
                    const hijriDate = moment(formattedDate, 'iYYYY', true)
                    if (hijriDate.isValid()) {
                        return date
                    } else {
                        return moment(date).format('iYYYY')
                    }
                }

            }
        },
        watch: {
            value(newValue) {
                if (!newValue) return

                const [option, values] = newValue.split('#')
                this.selectedOption = option
                
                if (values) {
                    const [from, to] = values.split('$')
                    if (option === 'year') {
                        moment.locale('en-us')
                        this.fromYear = from ? moment(from, 'iYYYY').toDate() : null
                        this.toYear = to ? moment(to, 'iYYYY').toDate() : null
                    } else if (option === 'month') {
                        moment.locale('en-us')
                        this.fromMonth = from ? moment(from, 'iYYYY-iMM').toDate() : null
                        this.toMonth = to ? moment(to, 'iYYYY-iMM').toDate() : null
                    } else if (option === 'date') {
                        moment.locale('en-us')
                        this.fromDate = from ? moment(from, 'iYYYY-iMM-iDD').toDate() : null
                        this.toDate = to ? moment(to, 'iYYYY-iMM-iDD').toDate() : null
                    }
                } else {
                    this.fromYear = ''
                    this.toYear = ''
                    this.fromMonth = null
                    this.toMonth = null
                    this.fromDate = null
                    this.toDate = null
                }
            },
            selectedOption() {
                this.$emit('input', this.formattedValue)
            },
            fromYear() {
                const dateValue = this.formattedValue
                this.$emit('input', dateValue)
                moment.locale('en-us')
                
                this.minHijriYear = moment((Number(dateValue.split('#')[1].split('$')[0]) + 1).toString(), 'iYYYY').toDate()
            },
            toYear() {
                const dateValue = this.formattedValue
                this.$emit('input', dateValue)
                moment.locale('en-us')
                this.maxHijriYear = moment((Number(dateValue.split('#')[1].split('$')[1]) + 1).toString(), 'iYYYY').toDate()
            },
            fromMonth() {
                const dateValue = this.formattedValue
                this.$emit('input', dateValue)
                moment.locale('en-us')
                this.minHijriMonth = moment(dateValue.split('#')[1].split('$')[0], 'iYYYY-iMM').toDate()
            },
            toMonth() {
                const dateValue = this.formattedValue
                this.$emit('input', dateValue)
                moment.locale('en-us')
                this.maxHijriMonth = moment(dateValue.split('#')[1].split('$')[1], 'iYYYY-iMM').toDate()
            },
            fromDate() {
                const dateValue = this.formattedValue
                this.$emit('input', dateValue)
                moment.locale('en-us')
                this.minHijriDate = moment(dateValue.split('#')[1].split('$')[0], 'iYYYY-iMM-iDD').toDate()
            },
            toDate() {
                const dateValue = this.formattedValue
                this.$emit('input', dateValue)
                moment.locale('en-us')
                this.maxHijriDate = moment(dateValue.split('#')[1].split('$')[1], 'iYYYY-iMM-iDD').toDate()
            }
        },
        created() {
            this.$nextTick(() => {
                if (this.value) {
                    const [option, values] = this.value.split('#')
                    this.selectedOption = option

                    if (values) {
                        const [from, to] = values.split('$')
                        if (option === 'year') {
                            moment.locale('en-us')
                            this.fromYear = from ? moment(from, 'iYYYY').toDate() : null
                            this.toYear = to ? moment(to, 'iYYYY').toDate() : null
                        } else if (option === 'month') {
                            moment.locale('en-us')
                            this.fromMonth = from ? moment(from, 'iYYYY-iMM').toDate() : null
                            this.toMonth = to ? moment(to, 'iYYYY-iMM').toDate() : null
                        } else if (option === 'date') {
                            moment.locale('en-us')
                            this.fromDate = from ? moment(from, 'iYYYY-iMM-iDD').toDate() : null
                            this.toDate = to ? moment(to, 'iYYYY-iMM-iDD').toDate() : null
                        }
                    }
                }
            })
        }
    }
</script>

